import React from 'react';
import { generatePath } from 'react-router-dom';
import CallRecordItemV2 from 'flow/components/call-history-v2/CallRecordItemV2';
import VoiceMessageItemV2 from 'flow/components/call-history-v2/VoiceMessageItemV2';
import ListRowFrame from 'flow/components/nav/list-keys/ListRowFrame';
import { CallRecordKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { TypedMap } from 'flow/types/TypedMap';
import { ExtensionVoiceMessage } from 'flow/types/VoiceMessage';
import { DateGroupedRowProps } from './DateGroupedList';

// The row gets its call or voicemail as a key or an Immutable map, not as a
// row object. The list makes new row objects each time its data changes, so a
// row object would render every row each time.
interface Props extends DateGroupedRowProps {
    callRecordKey?: CallRecordKey;
    voiceMessage?: TypedMap<ExtensionVoiceMessage>;
    isFocusable: boolean;
    isSelected: boolean;
}

const CallHistoryListItemV2 = ({
    callRecordKey,
    voiceMessage,
    index,
    isFocusable,
    isSelected,
    tabStopStore,
    tabStopKey,
    onUnmountWithFocus,
}: Props) => (
    <ListRowFrame
        index={index}
        isFocusable={isFocusable}
        tabStopStore={tabStopStore}
        tabStopKey={tabStopKey}
        onUnmountWithFocus={onUnmountWithFocus}
    >
        {voiceMessage ? (
            <VoiceMessageItemV2
                voiceMessage={voiceMessage}
                isSelected={isSelected}
            />
        ) : (
            callRecordKey && (
                // The link is the contact name inside the card, stretched
                // over the whole card, so the call button, the menu and the
                // voicemail player sit beside it rather than inside a link.
                <CallRecordItemV2
                    callRecordKey={callRecordKey}
                    segmentContext="Personal call detail"
                    compact={true}
                    selected={isSelected}
                    showAvatar={true}
                    pageType="personal"
                    linkTo={generatePath(routes['calls.callRecordKey'], {
                        callRecordKey,
                    })}
                    className={
                        isSelected
                            ? 'bg-gray-200 hover:bg-gray-200'
                            : 'hover:bg-gray-200'
                    }
                />
            )
        )}
    </ListRowFrame>
);

export default React.memo(CallHistoryListItemV2);
